import track from 'js/helpers/analytics'

/**
 * Replaces accented (latin) characters in a string
 * Wrapped in self-invoking anonymous function to make sure the regex is only created once
 *
 * @param {String} string to transform
 * @return {String} transformed string without accented (latin) characters
 */
const replaceAccents = (function() {

    const charmap = { // https://github.com/dodo/node-slug/blob/master/slug.js
        'à':'a', 'á':'a',
        'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', 'æ': 'ae', 'ç': 'c', 'è': 'e',
        'é': 'e', 'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',
        'ð': 'd', 'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
        'ő': 'o', 'ø': 'o', 'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u', 'ű': 'u',
        'ý': 'y', 'þ': 'th', 'ÿ': 'y', 'ß': 'ss',
    }
    const needles = Object.keys(charmap).join('|')
    const regex =  new RegExp(needles, 'g')

    return haystack => haystack.replace(regex, match => charmap[match])

})()

/**
 * Automatically binds click event handler on ready
 * If definition tags need to be transformed, call processDefinitions( el )
 */
export default {
    vuex: {
        actions: {
            showDefinition: ({dispatch}, definitionTag) => {
                track.event('definition', 'show', definitionTag)
                dispatch('SHOW_DEFINITION', definitionTag)
                dispatch('SHOW_MODAL', 'Glossary')
            }
        }
    },
    mounted: function() {
        this.$nextTick( this.bindClick )
    },
    methods: {

        /**
         * Binds a click handler to this component's element
         * which checks if the clicked (child) element is a definition
         * then it opens the definition popover
         */
        bindClick: function() {

            this.$el.onclick = e => {

                // check if user clicked on definition link

                e = e || event
                const anchor = this.findParentElement('a', e.target || e.srcElement)

                if (anchor && anchor.dataset.definition != undefined) {
                    e.preventDefault()
                    e.stopPropagation()

                    const tag = anchor.dataset.definition || this.slugify(anchor.innerText)
                    this.showDefinition(tag)
                }

            }

        },

        /**
         * Find first parent element (including self) with tagName [tagname]
         * @param  {String} tagname to search for (e.g. 'a')
         * @param  {DomElement} el  deepest child to start searching

         * @return {DomElement|null} null if not found, else the found DomElement
         */
        findParentElement: function (tagname, el) {
            while (el) {
                if ( (el.nodeName || el.tagName).toLowerCase() === tagname.toLowerCase() ) {
                    return el
                }
                el = el.parentNode
            }
            return null;
        },

        /**
         * Runs the html replacer for definitions
         * @param  {DomElement} el  the element to parse
         */
        processDefinitions: function( el ) {
            this.htmlReplace(el, this.definitionReplacer)
        },

        /**
         * Transforms content into url-safe slug
         * @param  {String} content  the text to transform
         * @return {String} url-safe string
         */
        slugify: function (content) {

            const newContent = content.toLowerCase().trim()
              .replace(/&/g, '-and-')      // Replace & with 'and'
              .replace(/[\s\W-]+/g, '-')   // Replace spaces, non-word characters and dashes with a single dash (-)
              .replace(/-$/, '')           // Remove trailing dash

            return replaceAccents(newContent)

        },

        /**
         * Finds all definitions marked: "#(definition)" or "#[Definition Text](definition-tag)"
         * and replaces them with an html string
         *
         * @param  {String} content The text of an html element
         * @return {String|False} false if no definition found, a replacement otherwise
         */
        definitionReplacer: function(content) {
            let replaced = false
            const newContent = content.replace(/\#(\[([^\[\]]*)\])?\(([^\(\)]*)\)/g, function(match, _, p2, p3) {
                replaced = true
                // if custom text is not set, then leave data-definition empty: will be tagified when clicked on
                return '<a href="#" data-definition="' + (p2 ? p3 : '') + '">' + (p2 || p3) + '</a>'
            })

            return replaced ? newContent : false
        },

        /**
         * Walks recursively through node and runs the given replaces on each textNode
         *
         * @param  {DomElement} node    The node to start searching
         * @param  {(String) => (String|False)} replacer  function that searches the text
         */
        htmlReplace: function(node, replacer) {

            const nodes = node.childNodes;

            for (let i = 0; i < nodes.length; i++) {

                const n = nodes[i]

                if (n.nodeType == n.TEXT_NODE) {

                    const found = replacer(n.textContent)
                    if ( found === false ) {
                        continue
                    }

                    let replacementNode = document.createElement('span')
                    replacementNode.innerHTML = found
                    n.parentNode.insertBefore(replacementNode, n)
                    n.parentNode.removeChild(n)

                } else {
                    // recursion
                    this.htmlReplace(n, replacer)
                }

            }

        }

    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/components/elements/autoGlossaryMixin.js